import { Routes } from '@angular/router';
import {tenantGuard} from './core/auth/tenantGuard';
import {roleGuard} from './core/auth/role-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/shared/unauthorized/unauthorized').then(m => m.Unauthorized),
  },
  {
    path: '',
    canActivate: [tenantGuard, roleGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard-overview/dashboard-overview').then(m => m.DashboardOverview)
      },
      {
        path: 'measurements',
        loadComponent: () =>
          import('./features/measurement-overview/measurement-overview').then(m => m.MeasurementOverview)
      },
      {
        path: 'details',
        loadComponent: () =>
          import('./features/dashboard-details/dashboard-details').then(m => m.DashboardDetails)
      },
      {
        path: 'productiondata',
        loadComponent: () =>
          import('./features/production-data/production-data').then(m => m.ProductionData)
      },
      {
        path: 'mould-configuration/:id',
        loadComponent: () =>
          import('./features/configurations/mould-configuration/mould-configuration').then(m => m.MouldConfiguration)
      },
      {
        path: 'mould-configuration',
        loadComponent: () =>
          import('./features/configurations/mould-configuration/mould-configuration').then(m => m.MouldConfiguration)
      },
      {
        path: 'mould-configurations',
        loadComponent: () =>
          import('./features/configurations/mould-configuration-list/mould-configuration-list').then(m => m.MouldConfigurationList)
      },
      {
        path: 'monthly-report',
        loadComponent: () =>
          import('./features/monthly-report/monthly-report').then(m => m.MonthlyReport)
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/users/user-list/user-list').then(m => m.UserList)
      },
      {
        path: 'file-management',
        loadComponent: () =>
          import('./features/file-management/file-management').then(m => m.FileManagement),
      }
    ]
  },
  {
    path: 'import',
    loadComponent: () =>
      import('./features/import-data/import-data').then(m => m.ImportData),
    canActivate: [tenantGuard]
  }
];
